module.exports = __webpack_public_path__ + "static/logotype-532574d713139272c4959d4825c0b8da.svg";